import * as React from "react";
import { Navigate, useLocation, useNavigate } from "react-router";

import { useKeycloak } from "../../../contexts/KeycloakContext";
import { AuthLayout } from "../../../components/shared/AuthLayout/AuthLayout";
import { AuthButton } from "../../../components/shared/AuthButton/AuthButton";
import authStyles from "../../../components/shared/AuthLayout/AuthLayout.module.css";
import styles from "./LoginPage.module.css";

const LoginBrandContent: React.FC = () => (
  <>
    <span className={authStyles.brandBadge}>
      <span className={authStyles.brandBadgeDot} />
      Портал разработки документации
    </span>
    <h1 className={authStyles.brandHeadline}>
      Управляйте проектами<br />
      и документацией<br />
      в одном месте
    </h1>
    <p className={authStyles.brandSubtitle}>
      Согласование разделов, реестр замечаний и контроль готовности проектов
      X5 Недвижимость — прозрачно и на любом устройстве.
    </p>

    <div className={styles.floatingCardsArea}>
      <div className={`${authStyles.glassCard} ${styles.docCard}`}>
        <div className={styles.docCardHeader}>
          <span className={styles.docCardIcon}>
            <i className="fa-regular fa-file-pdf" />
          </span>
          <div className={styles.docCardMeta}>
            <div className={styles.docCardTitle}>Рабочая документация</div>
            <div className={styles.docCardSub}>Раздел 4 · КЖ</div>
          </div>
        </div>
        <div className={styles.progressRow}>
          <div className={styles.progressTrack}>
            <div className={styles.progressFill} />
          </div>
          <span className={styles.progressPct}>72%</span>
        </div>
      </div>

      <div className={`${authStyles.glassCard} ${styles.checkCard}`}>
        <span className={styles.checkCardIcon}>
          <i className="fa-solid fa-check" />
        </span>
        <div>
          <div className={styles.checkCardTitle}>Замечание закрыто</div>
          <div className={styles.checkCardSub}>12 из 15 выполнено</div>
        </div>
      </div>
    </div>
  </>
);

export const LoginPage: React.FC = () => {
  const { login, authenticated } = useKeycloak();
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = React.useState(false);

  if (authenticated) {
    const from = (location.state as { from?: { pathname?: string } })?.from?.pathname;
    return <Navigate to={from || "/"} replace />;
  }

  const handleLogin = () => {
    if (loading) return;
    setLoading(true);
    login();
  };

  return (
    <AuthLayout brandContent={<LoginBrandContent />}>
      <div className={styles.formWrap}>
        <h2 className={styles.formTitle}>Вход в портал</h2>
        <p className={styles.formSubtitle}>
          Войдите через корпоративную учётную запись или зарегистрируйтесь для
          доступа к проектной документации.
        </p>

        <AuthButton loading={loading} onClick={handleLogin}>
          <i className="fa-solid fa-id-badge" style={{ fontSize: 16 }} />
          Войти
        </AuthButton>

        <div className={styles.divider}>
          <span className={styles.dividerLine} />
          <span className={styles.dividerText}>или</span>
          <span className={styles.dividerLine} />
        </div>

        <AuthButton variant="secondary" onClick={() => navigate("/registration")}>
          <i className="fa-solid fa-user-plus" style={{ color: "var(--accent-green)" }} />
          Зарегистрироваться
        </AuthButton>

        <p className={styles.legalNote}>
          Продолжая, вы принимаете условия использования портала X5 CPDA
        </p>
      </div>
    </AuthLayout>
  );
};
